import { useHasPerPipelineAccess } from './useHasPerPipelineAccess';
import { usePipelineId } from 'crm-object-board-core/pipeline';
export const useSelectedPipelineIdByAccess = () => {
  const hasPerPipelineAccess = useHasPerPipelineAccess();
  const pipelineId = usePipelineId();
  return hasPerPipelineAccess ? pipelineId : undefined;
};